/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'ai-summary-label': 'Oppsummer',
  'copy-content-link-label': 'Kopier kobling',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Begynn å skrive for å søke etter en etikett',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Alle',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Filtrer søk etter produkt',
  'dynamic-cards-search-page.atlas.for': 'for',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Kalender',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Bli med på møte',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Møtekobling',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Bli med på møte',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Tidligere hendelser',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Periodisk hendelse',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Gjentakende',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Kommende hendelser',
  'dynamic-cards-search-page.compass.owner-name': 'Eid av {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Nivå {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Finn innhold',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Valgt',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Forslag',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Valgt',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Forslag',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Finn personer',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Valgt',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Finn etiketter',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Finn områder',
  'dynamic-cards-search-page.connect_third_party_product_description':
    'Koble til kontoen din for å se manglende resultater',
  'dynamic-cards-search-page.connect_third_party_product_title': 'Administratoren din har lagt til {product}!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} er nå tilgjengelig!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': 'Fra-datoen må være før Til-datoen',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': 'Fra-datoen kan ikke være i fremtiden',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': 'Til-datoen kan ikke være i fremtiden',
  'dynamic-cards-search-page.date.filter.last.month': 'De siste 30 dagene',
  'dynamic-cards-search-page.date.filter.last.week': 'De siste 7 dagene',
  'dynamic-cards-search-page.date.filter.last.year': 'Det siste året',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Generer svar',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Nylige',
  'dynamic-cards-search-page.error_primary': 'Vi har problemer med å søke',
  'dynamic-cards-search-page.error_secondary':
    'Det kan skyldes et midlertidig problem. Det beste er å <btn>prøve på nytt</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Eksterne personer #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Fjern filter',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'Når som helst',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'De siste 30 dagene',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'De siste 7 dagene',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Det siste året',
  'dynamic-cards-search-page.filter.last.updated.today': 'I dag',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'I går',
  'dynamic-cards-search-page.filter.type.answer': 'Svar',
  'dynamic-cards-search-page.filter.type.attachment': 'Vedlegg',
  'dynamic-cards-search-page.filter.type.blogpost': 'Blogginnlegg',
  'dynamic-cards-search-page.filter.type.branch': 'Grener',
  'dynamic-cards-search-page.filter.type.calendar': 'Kalendere',
  'dynamic-cards-search-page.filter.type.comment': 'Kommentarer',
  'dynamic-cards-search-page.filter.type.commit': 'Commiter',
  'dynamic-cards-search-page.filter.type.component': 'Komponenter',
  'dynamic-cards-search-page.filter.type.conversation': 'Samtaler',
  'dynamic-cards-search-page.filter.type.database': 'Databaser',
  'dynamic-cards-search-page.filter.type.design': 'Design',
  'dynamic-cards-search-page.filter.type.documents': 'Dokumenter',
  'dynamic-cards-search-page.filter.type.embed': 'Smartkoblinger',
  'dynamic-cards-search-page.filter.type.goal': 'Mål',
  'dynamic-cards-search-page.filter.type.issue': 'Saker',
  'dynamic-cards-search-page.filter.type.message': 'Meldinger',
  'dynamic-cards-search-page.filter.type.page': 'Sider',
  'dynamic-cards-search-page.filter.type.placeholder': 'Finn type',
  'dynamic-cards-search-page.filter.type.presentation': 'Presentasjoner',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pull-forespørsler',
  'dynamic-cards-search-page.filter.type.question': 'Spørsmål',
  'dynamic-cards-search-page.filter.type.repository': 'Repositorier',
  'dynamic-cards-search-page.filter.type.space': 'Områder',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Områdekalendere',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Regneark',
  'dynamic-cards-search-page.filter.type.video': 'Videoer',
  'dynamic-cards-search-page.filter.type.web-page': 'Nettsider',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Tavler',
  'dynamic-cards-search-page.filter.type.work-item': 'Arbeidsoppgaver',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Fjern alle',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filter',
  'dynamic-cards-search-page.filters.names.content': 'Innhold under',
  'dynamic-cards-search-page.filters.names.contributor': 'Bidragsyter',
  'dynamic-cards-search-page.filters.names.labels': 'Etikett',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Titteltreff',
  'dynamic-cards-search-page.github-branch-result.label': 'Branch',
  'dynamic-cards-search-page.github-commit-result.label': 'Commit',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Pull-forespørsel',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Finn prosjekter',
  'dynamic-cards-search-page.landing_primary': 'Kom i gang med filtre for dynamiske kort',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Dokumenter',
  'dynamic-cards-search-page.legacy-third-party-result.google-presentation-label': 'Presentasjoner',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Regneark',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'Vi fant ikke noe som samsvarte med søket',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Det ser ut som du har noen filtre aktivert. Du kan prøve å fjerne dem.',
  'dynamic-cards-search-page.nouns.goal': 'Mål',
  'dynamic-cards-search-page.nouns.tag': 'Tagg',
  'dynamic-cards-search-page.nouns.tags': 'Tagger',
  'dynamic-cards-search-page.number_of_results': 'Viser {numberOfResults,number} av {totalCount,number} resultater',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': 'Autoriseringen for {product} mislyktes.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'Autoriseringen for {product} er fullført.',
  'dynamic-cards-search-page.oauth-message-connect': 'Koble til',
  'dynamic-cards-search-page.products.custom-website': 'Nettside',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Sorter etter opprettet (nyest)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Opprettet (nyest)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Oppdatert (nyest)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': 'Sorter etter oppdatert (nyest)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'Endre listesortering',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Neste',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Filtrer etter produkt for å få flere relevante søkeresultater.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'Søk i alle bedriftens arbeidsområder',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'Disse alternativene endres avhengig av produktet du filtrerer etter, for å hjelpe deg oppnå bestemte resultater.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Finn akkurat det du leter etter',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Vedlegg',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Vedlagt {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Lyd',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Bilde',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Oppdatert {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Privat kanal',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Fjern nylige søk – ikon',
  'dynamic-cards-search-page.search-result.repository-label': 'Repositorium',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Gruppemelding med eksterne brukere} =2 {{name1} og {name2}} =3 {{name1}, {name2} og {name3}} =4 {{name1}, {name2}, {name3} og {overflowContributorCount} til} one {{name1}} other {{name1}, {name2}, {name3} og {overflowContributorCount} til}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'ukjent-kanal',
  'dynamic-cards-search-page.search_result_type_answer': 'Svar',
  'dynamic-cards-search-page.search_result_type_branch': 'Gren',
  'dynamic-cards-search-page.search_result_type_card': 'Kort',
  'dynamic-cards-search-page.search_result_type_comment': 'Kommenter',
  'dynamic-cards-search-page.search_result_type_component': 'Komponent',
  'dynamic-cards-search-page.search_result_type_dashboard': 'Dashbord',
  'dynamic-cards-search-page.search_result_type_document': 'Dokument',
  'dynamic-cards-search-page.search_result_type_embed': 'Smartkobling',
  'dynamic-cards-search-page.search_result_type_folder': 'Mappe',
  'dynamic-cards-search-page.search_result_type_presentation': 'Presentasjon',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pull-forespørsel',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'SharePoint-dokument',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Områdekalender',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Regneark',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Ikke gjenkjent',
  'dynamic-cards-search-page.search_result_type_work_item': 'Arbeidsoppgave',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'Administratoren din har lagt til <strong>{product}.</strong>{br} Koble til kontoen din for å se manglende resultater, inkludert dokumenter som bare du har tilgang til.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} er nå tilgjengelig!</strong>{br} Koble til kontoen din for å se manglende resultater, inkludert dokumenter bare du har tilgang til.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Godkjenn',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': 'Autoriseringen for {product} mislyktes.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': 'Autoriseringen for {product} er fullført.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filtrer etter alle apper',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filtrer etter flere apper',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Arkivert',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'I faresonen',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Avbrutt',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Fullført',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Ikke i rute',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'I rute',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'Satt på pause',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'Venter',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} kapittel i denne videoen} other {{chapterCount,number} kapitler i denne videoen}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'videoikon',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Miniatyrbilde for video',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'er tilordnet',
  'dynamic-cards-search-page.work-item-creator.created': 'opprettet',
  'dynamic-cards-search-page.work-item-status.for': 'for',
  'dynamic-cards-search-page.work-item-ticket.label': 'Støtteforespørsel',
  'dynamic-cards-search-page.work-item.label': 'Arbeidsoppgave',
  'initialsAvatar.label': 'Avatar med initialer',
  'personAvatar.label': 'Personavatar',
  'search-page.results.private-result-label': 'Privat',
  'search-page.results.private-result-tooltip': 'Bare synlig for deg',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} medlem} other {{memberCount,number} medlemmer}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Kanal',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Kanal',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} medlem} other {{count,number} medlemmer}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Sist aktiv {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'ukjent-kanal',
  'search-page.results.product-results.third-party.external-people-label': 'Eksterne personer',
  'search-page.results.product-results.third-party.external-person-label': 'Ekstern person',
  'search-page.results.product-results.third-party.last-active': 'Sist aktiv {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Melding',
  'search-page.results.product-results.third-party.no-contributors-label': 'Eksterne personer i #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} er en privat samtale',
  'search-page.results.product-results.third-party.thread-type-label': 'Tråd',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} i #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} og {remainingContributorsCount} til} other {{title} og {remainingContributorsCount} til}}',
  'search-page.results.restricted-result-label': 'Begrenset',
  'search-page.results.restricted-result-tooltip': 'Bare synlig for bestemte personer',
  'search-page.show-more-breadcrumbs-button-label': 'Vis flere brødsmuler',
  'search-page.verified-icon-label': 'Verifisert',
  'search-page.verified-icon-tooltip-message': 'Denne siden er bekreftet av en eier eller administrator.',
  'search-result.result.count': '{count, plural, one {Viser {count} resultat} other {Viser {count} resultater}}',
  'search-result.user-mention.external-person': 'Ekstern person',
};
